<!-- 公共底部 -->
<template>
    <div class="footer_wrap">

        <div class="left">
            <!-- <img src="../assets/imgs/footerlogo.png" alt=""> -->
            <span>北京盈科千信科技有限公司</span>
        </div>

        <ul class="right">
            
            <li>地址： 北京市海淀区中关村南大街48号</li>
            <li>邮箱： product@increscence.net</li>
            <li>Copyright © {{year}}
                <img src="../assets/imgs/copy_n.png" alt="">
                <a href="https://beian.miit.gov.cn" target="_blank">京ICP备15054044号-1</a>

            </li>
        </ul>
    </div>
</template>

<script>
export default {
    data() {
        return {
            year: new Date().getFullYear(), //当前年份
        };
    },
};
</script>
<style scoped lang='less'>
.footer_wrap {
    display: flex;
    width: 100%;
    min-width: 1280px;
    // min-width: 1350px;
    height:80px;
    // width: 52.5%;
    margin: auto;
    
    // min-width: 1800px;
//  min-width: 1920px;
//   max-width: 2500px;
    justify-content: center;
    align-items: center;
    background: url("../assets/imgs/2.0/foot.jpg");
    // background: #fd8d1c;
}
.left {
    // width: 125px;
     font-size: 18px !important;
    // font-size: 16px;
    margin-right: 30px;
    color: #ffffff;
    img {
        width: 100%;
        height: 100%;
    }
    li + li {
        margin-top: 14px;
        
    }
}
.right {
    font-size: 15px !important;
    // font-size: 16px;
    border-left: 2px solid #c5c2c2;

    padding-left: 30px;
    color: rgb(0, 0, 0);
    font-size: 10px;
    a {
        color: rgb(8, 8, 8);
    }
    li {
        line-height: 20px;
    }
    img {
        width: 20px;
        vertical-align: middle;
    }
}
</style>